"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadExcel = exports.downloadCSV = exports.downloadPDF = exports.dataURIToBlob = void 0;
var file_saver_1 = require("file-saver");
var json2csv_1 = require("json2csv");
// @ts-ignore
var zipcelx_1 = __importDefault(require("zipcelx"));
function dataURIToBlob(b64Data, contentType, sliceSize) {
    if (contentType === void 0) { contentType = ''; }
    if (sliceSize === void 0) { sliceSize = 512; }
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
}
exports.dataURIToBlob = dataURIToBlob;
function downloadPDF(filename, data) {
    try {
        var blob = new Blob([data], { type: "text/pdf;charset=utf-8" });
        file_saver_1.saveAs(blob, filename);
    }
    catch (err) {
        console.error(err);
    }
}
exports.downloadPDF = downloadPDF;
function downloadCSV(filename, json) {
    try {
        var csv = json2csv_1.parse(json);
        var blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
        file_saver_1.saveAs(blob, filename + ".csv");
    }
    catch (err) {
        console.error(err);
    }
}
exports.downloadCSV = downloadCSV;
function downloadExcel(filename, data) {
    var config = {
        filename: filename,
        sheet: { data: data }
    };
    zipcelx_1.default(config);
}
exports.downloadExcel = downloadExcel;
